// extracted by mini-css-extract-plugin
export default {"indicatorWrap":"DropdownIndicatorSearch_indicatorWrap__5bNIY"};